(function () {
  var root = document.querySelector("[data-gvm-page]");
  if (!root) return;
  var buttons = root.querySelectorAll("[data-gvm-stage]");
  if (!buttons.length) return;
  root.classList.add("is-enhanced");

  function show(id) {
    buttons.forEach(function (button) {
      var on = button.getAttribute("data-gvm-stage") === id;
      button.classList.toggle("is-active", on);
      button.setAttribute("aria-selected", on ? "true" : "false");
    });
    root.querySelectorAll("[data-gvm-card]").forEach(function (card) {
      card.classList.toggle("is-active", card.getAttribute("data-gvm-card") === id);
    });
  }

  buttons.forEach(function (button) {
    button.addEventListener("click", function () {
      show(button.getAttribute("data-gvm-stage"));
    });
  });
})();

(function () {
  var nav = document.querySelector("[data-gvm-subnav]");
  if (!nav) return;
  var links = Array.prototype.slice.call(nav.querySelectorAll("a[href^='#']"));
  links.forEach(function (link) {
    var id = link.getAttribute("href").slice(1);
    if (!document.getElementById(id)) link.hidden = true;
  });
  var visible = links.filter(function (link) { return !link.hidden; });
  if (!visible.length) return;

  function mark() {
    var current = visible[0];
    visible.forEach(function (link) {
      var el = document.getElementById(link.getAttribute("href").slice(1));
      if (!el || !el.getClientRects().length) return;
      if (el.getBoundingClientRect().top < 180) current = link;
    });
    visible.forEach(function (link) {
      link.classList.toggle("is-active", link === current);
    });
  }

  mark();
  window.addEventListener("scroll", mark, { passive: true });
})();

(function () {
  var root = document.querySelector("[data-gvm-page]");
  if (!root) return;
  var federal = root.querySelector("#gvm-tab-federal");
  var state = root.querySelector("#gvm-tab-inhouse");
  if (!federal || !state) return;

  function openFromHash() {
    var id = (location.hash || "").replace("#", "");
    if (id === "federally-approved" || id === "stages" || id === "compare") federal.checked = true;
    if (id === "in-house-build" || id === "in-house-plate") state.checked = true;
  }

  federal.addEventListener("change", function () {
    if (federal.checked && history.replaceState) history.replaceState(null, "", "#federally-approved");
  });
  state.addEventListener("change", function () {
    if (state.checked && history.replaceState) history.replaceState(null, "", "#in-house-build");
  });

  openFromHash();
  window.addEventListener("hashchange", openFromHash);
})();
